import styled from 'styled-components';

export const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: ${({ horizontal }) => horizontal ? 'row' : 'column'};
  padding: ${({ paddingOverride }) => paddingOverride || 'var(--gameday-section-padding-sm)'};
  margin: ${({ marginOverride }) => marginOverride || '24px 16px'};
  background-color: var(--gameday-background-color);
  color: var(--gameday-primary-font-color);

  button {
    margin-left: ${({ horizontal }) => horizontal ? '20px' : '0'};
    background: ${({ disabled }) => disabled ? 'var(--gameday-error-fallback-button-disabled)' : 'var(--gameday-error-fallback-button-background)'};
    
    color: var(--gameday-error-fallback-button-text);
    border-radius: 8000px;
    min-width: 200px;
    min-height: 48px;
    font-size: 16px;
    &:hover {
      background: ${({ disabled }) => disabled ? 'var(--gameday-error-fallback-button-disabled)' : 'var(--gameday-error-fallback-button-background)'};
      color: var(--gameday-error-fallback-button-text);
    }
  }

  p {
    text-align: center;
    margin-left: ${({ horizontal }) => horizontal ? '20px' : '0'};
    margin-bottom: ${({ horizontal }) => horizontal ? '0' : '1rem'};
    margin-top: ${({ horizontal }) => horizontal ? '0' : '1rem'};
  }

  svg {
    stroke: var(--gameday-primary-font-color);
    circle {
      stroke: var(--gameday-secondary-font-color);
    }
  }
`;
